import { FetchModelResponse } from '@cian/http-api';

import { IDeleteOfferFromComparisonResponseSchema } from 'shared/repositories/offers-comparison/entities/delete_offer_from_comparison/DeleteOfferFromComparisonResponseSchema';

export const mapDeleteOfferFromComparisonResponse = (
  response: IDeleteOfferFromComparisonResponseSchema,
): FetchModelResponse<200, 'json', IDeleteOfferFromComparisonResponseSchema> => {
  return {
    statusCode: 200,
    response,
  };
};
